import { STATUS_TYPE_ENUM } from 'enums';
import type { Book, User } from 'library/types';

type Identifiable<TId extends PropertyKey> = {
  id: TId;
};

export const sortByText = <T>(
  items: readonly T[],
  getText: (item: T) => string | null | undefined,
  locale?: string
): T[] => [...items].sort((left, right) => (getText(left) ?? '').localeCompare(getText(right) ?? '', locale));

export const prepareActiveUserOptions = (users: readonly User[]): User[] =>
  sortByText(
    users.filter((user) => user.status === STATUS_TYPE_ENUM.ACTIVE),
    (user) => user.nameSurname
  );

export const sortBooksByCompanyName = (books: readonly Book[]): Book[] => sortByText(books, (book) => book.companyName);

export const selectByIds = <TItem extends Identifiable<PropertyKey>>(
  items: readonly TItem[],
  ids: readonly PropertyKey[]
): TItem[] => {
  const itemsById = new Map(items.map((item) => [item.id, item]));

  return ids.reduce<TItem[]>((selectedItems, id) => {
    const item = itemsById.get(id);

    if (item) selectedItems.push(item);

    return selectedItems;
  }, []);
};

export const toIds = <TId extends PropertyKey>(items: readonly Identifiable<TId>[]): TId[] =>
  items.map((item) => item.id);
